export default {
  export: '导出合同',
  create: '新建合同',
  select: '已选',
  items: '项',
  contractName: '合同名称',
  contractStatus: '合同状态',
  contractNum: '合同编号',
  contractType: '合同类型',
  contractPayType: '合同收支类型',
  contractAmount: '合同金额',
  operation: '操作',
  detail: '详情',
  delete: '删除',
  pay: '付款',
  receive: '收款',
  placeholder: '请输入内容搜索',
  contractStatusEnum: {
    fail: '审核失败',
    audit: '待审核',
    executing: '履行中',
    pending: '待履行',
    finish: '已完成',
  },
};
